import { useCallback, useEffect } from 'react';
import { styled } from 'styled-components';

import { Box } from 'components/Box/Box';
import { Button } from 'components/Button/Button';
import { useI18n } from 'i18n/hooks/useI18n';
import { colors, gutterWidth } from 'theme/theme';
import { LocalProductNotificationType } from 'types/LocalNotification/LocalProductNotificationType';
import { trackClicked } from 'utils/analytics/track/trackClicked';
import { trackEventOnce } from 'utils/analytics/track/trackEventOnce';
import { getStaticImageSrc } from 'utils/getImageSrc';
import { clearAdStore } from 'zustand-stores/adStore';
import { dismissLocalNotification } from 'zustand-stores/localNotificationsStore';

const CloseButton = styled(Button)`
  opacity: 0.999; /* is invisible without this, why? */
`;

export function SalarySurveyBanner() {
  const { i18n } = useI18n();

  const handleDismiss = useCallback(() => {
    dismissLocalNotification(LocalProductNotificationType.SALARY_SURVEY_CTA);
    clearAdStore();
  }, []);

  useEffect(() => {
    trackEventOnce('Displayed: Salary Survey Ad', {
      context: 'Header Banner',
    });
  }, []);

  return (
    <Box
      data-qa-id="banner-ad"
      data-ad-type="salary-survey"
      position="relative"
      zIndex={101}
      bg={colors.brandBlue}
      color="white"
      display="flex"
      py={12}
      pl={gutterWidth / 2}
      pr={gutterWidth / 2 - 16}
    >
      <Box
        position="absolute"
        left={0}
        top={0}
        width={1}
        height="100%"
        backgroundImage={`url('${getStaticImageSrc(
          'salary-survey-banner.svg',
        )}')`}
        backgroundSize="cover"
        backgroundPosition="center"
      />
      <Box
        position="relative"
        minHeight={[160, 80, null, 92]}
        width={1}
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        flexWrap={['wrap', 'nowrap', null, null]}
      >
        <Box
          pr={[0, 10, null, null]}
          mt={['5px', 0, null, null]}
          mb={[2, 0, null, null]}
          fontSize={[16, null, null, 18]}
        >
          {i18n(
            'Find out how much you could be earning with Nonprofit Salary Explorer.',
          )}
        </Box>
        <Button
          type="link"
          href="/nonprofit-salary-explorer"
          variant="secondary-white"
          onClick={() => {
            trackClicked('Clicked: Salary Survey Ad', {
              cta_type: 'Button',
              button_text: i18n('Take Our Survey'),
              url: '/nonprofit-salary-explorer',
              context: 'Header Banner',
            });
            handleDismiss();
          }}
        >
          <Box minHeight={24} display="flex" alignItems="center">
            <Box display="block">{i18n('Take Our Survey')}</Box>
          </Box>
        </Button>
      </Box>
      <CloseButton
        type="button"
        data-qa-id="close-banner-ad-button"
        onClick={handleDismiss}
        variant="tertiary-white"
        icon={{ type: 'normalized', name: 'close' }}
      />
    </Box>
  );
}
